@for (stage of stages; track stage) {
  <div class="row">
    <div class="offset-1 col-12">
      @if (stage.complete) {
        <h3>@if (!stage.passing) {
          <i class="far fa-times-circle failure"></i>
          }@if (stage.passing) {
          <i class="far fa-check-circle success"></i>
        }&#160; {{stage.label}}</h3>
      }
      @if (!stage.complete) {
        <h3><i class="fas fa-hourglass-half"></i>&#160; {{stage.label}}</h3>
      }
    </div>
  </div>
}








